import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["action", "actionId", "getHeaderTitle"];
import PropTypes from 'prop-types';
import AutomationBuilderCard from 'automation-ui-flow-core/canvas/AutomationBuilderCard';
import CustomCodeActionSummary from 'automation-ui-action-features/actions/custom-code/CustomCodeActionSummary';
import { DESCRIPTION } from 'automation-ui-action-features/constants/ActionCustomProperties';
import { jsx as _jsx } from "react/jsx-runtime";
function CustomCodeActionCard(_ref) {
  let {
      action,
      actionId,
      getHeaderTitle
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const description = action && action.getCustomProperty(DESCRIPTION);
  return /*#__PURE__*/_jsx(AutomationBuilderCard, Object.assign({}, rest, {
    headerTitle: getHeaderTitle({
      actionId: actionId
    }),
    content: description || /*#__PURE__*/_jsx(CustomCodeActionSummary, {})
  }));
}
CustomCodeActionCard.propTypes = {
  getHeaderTitle: PropTypes.func.isRequired,
  actionId: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};
export default CustomCodeActionCard;